import React from "react";
import AppBar from "../app-bar/app-bar";
import CartTable from "../data-tables-pharmacy/cart/cart-table";
import {useUser} from "../providers/user-context";
import {APP_BAR_HEIGHT} from "../components/common/app-layout";
import {Box} from "@mui/material";

function CartPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <Box sx={{display: "flex", mt: APP_BAR_HEIGHT, width: "100%", minWidth: 0}}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {tenantType === "PHARMACY" && <CartTable navOpen={navOpen} tenantType={tenantType}/>}
        </Box>
    );
}
export default CartPage;
